<style>
  /* Style Definitions */
  p.MsoNormal,
  li.MsoNormal,
  div.MsoNormal {
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 10.0pt;
    margin-left: 0in;
    line-height: 115%;
    font-size: 11.0pt;
    font-family: "Calibri", sans-serif;
  }

  h1 {
    mso-style-link: "Heading 1 Char";
    margin-top: .5in;
    margin-right: 0in;
    margin-bottom: 12.0pt;
    margin-left: .25in;
    text-indent: -.25in;
    line-height: 115%;
    font-size: 12.0pt;
    font-family: "Arial", sans-serif;
    font-weight: bold;
  }

  h2 {
    mso-style-link: "Heading 2 Char";
    margin-top: 16.0pt;
    margin-right: 0in;
    margin-bottom: 10.0pt;
    margin-left: 120.85pt;
    text-align: justify;
    text-justify: inter-ideograph;
    text-indent: -.3in;
    line-height: 115%;
    font-size: 12.0pt;
    font-family: "Arial", sans-serif;
    font-weight: normal;
  }

  p.MsoHeader,
  li.MsoHeader,
  div.MsoHeader {
    mso-style-link: "Header Char";
    margin: 0in;
    font-size: 11.0pt;
    font-family: "Calibri", sans-serif;
  }

  p.MsoFooter,
  li.MsoFooter,
  div.MsoFooter {
    mso-style-link: "Footer Char";
    margin: 0in;
    font-size: 11.0pt;
    font-family: "Calibri", sans-serif;
  }

  a:link,
  span.MsoHyperlink {
    color: blue;
    text-decoration: underline;
  }

  p {
    margin-right: 0in;
    margin-left: 0in;
    font-size: 12.0pt;
    font-family: "Times New Roman", serif;
  }

  p.MsoListParagraph,
  li.MsoListParagraph,
  div.MsoListParagraph {
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 10.0pt;
    margin-left: .5in;
    line-height: 115%;
    font-size: 11.0pt;
    font-family: "Calibri", sans-serif;
  }

  p.MsoListParagraphCxSpFirst,
  li.MsoListParagraphCxSpFirst,
  div.MsoListParagraphCxSpFirst {
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 0in;
    margin-left: .5in;
    line-height: 115%;
    font-size: 11.0pt;
    font-family: "Calibri", sans-serif;
  }

  p.MsoListParagraphCxSpMiddle,
  li.MsoListParagraphCxSpMiddle,
  div.MsoListParagraphCxSpMiddle {
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 0in;
    margin-left: .5in;
    line-height: 115%;
    font-size: 11.0pt;
    font-family: "Calibri", sans-serif;
  }

  p.MsoListParagraphCxSpLast,
  li.MsoListParagraphCxSpLast,
  div.MsoListParagraphCxSpLast {
    margin-top: 0in;
    margin-right: 0in;
    margin-bottom: 10.0pt;
    margin-left: .5in;
    line-height: 115%;
    font-size: 11.0pt;
    font-family: "Calibri", sans-serif;
  }

  p.Default,
  li.Default,
  div.Default {
    mso-style-name: Default;
    margin: 0in;
    text-autospace: none;
    font-size: 12.0pt;
    font-family: "Times New Roman", serif;
    color: black;
  }

  span.Heading2Char {
    mso-style-name: "Heading 2 Char";
    mso-style-link: "Heading 2";
    font-family: "Arial", sans-serif;
  }

  span.HeaderChar {
    mso-style-name: "Header Char";
    mso-style-link: Header;
  }

  span.FooterChar {
    mso-style-name: "Footer Char";
    mso-style-link: Footer;
  }

  .MsoChpDefault {
    font-family: "Calibri", sans-serif;
  }

  .MsoPapDefault {
    margin-bottom: 10.0pt;
    line-height: 115%;
  }

  div.WordSection1 {
    page: WordSection1;
  }

  div.WordSection2 {
    page: WordSection2;
  }

  /* List Definitions */
  ol {
    margin-bottom: 0in;
  }

  ul {
    margin-bottom: 0in;
  }
</style>

<div class="bg-transparent text-white p-3">
  <span lang=EN-SG style='font-size:11.0pt;font-family:"Calibri",sans-serif'><br clear=all
      style='page-break-before:always'>
  </span>
  <p class=MsoNormal align=center style='margin-bottom:0in;text-align:center;
line-height:normal'><b><span lang=EN-SG style='font-family:"Arial",sans-serif'>DATA
        PROTECTION NOTICE FOR CUSTOMERS</span></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif'>This
      Data Protection Notice (“<b>Notice</b>”) sets out the basis which <i><span style='background:transparent'>KACHIING
          PTE LTD</span></i> (“<b>we</b>”, “<b>us</b>”,
      or “<b>our</b>”) may collect, use, disclose or otherwise process personal data
      of our customers in accordance with the Personal Data Protection Act (“<b>PDPA</b>”).
      This Notice applies to personal data in our possession or under our control,
      including personal data in the possession of organisations which we have
      engaged to collect, use, disclose or process personal data for our purposes. </span></p>

  <p style='margin:0in;text-align:justify;text-justify:inter-ideograph;
background:transparent'><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>&nbsp;</span></p>

  <p style='margin:0in;text-align:justify;text-justify:inter-ideograph;
background:transparent'><b><u><span lang=EN-SG style='font-size:11.0pt;font-family:
"Arial",sans-serif;color:white'>PERSONAL DATA </span></u></b></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;background:transparent'><b><u><span lang=EN-SG
          style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'><span
            style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;text-indent:-.5in;background:
transparent'><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>1.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>As used in this Notice:</span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;background:transparent'><span lang=EN-SG
      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;background:transparent'><span lang=EN-SG
      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'>“<b>customer</b>”
      means an individual who (a) has contacted us through any means to find out more
      about any goods or services we provide, or (b) may, or has, entered into a
      contract with us for the supply of any goods or services by us; and</span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;background:transparent'><span lang=EN-SG
      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;background:transparent'><span lang=EN-SG
      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'>“<b>personal
        data</b>” means data, whether true or not, about a customer who can be
      identified: (a) from that data; or (b) from that data and other information to
      which we have or are likely to have access. </span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;background:transparent'><span lang=EN-SG
      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;text-indent:-.5in;background:
transparent'><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>2.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>Depending on the nature of your interaction with us, some examples
      of personal data which we may collect from you include <span style='background:
transparent'>residential address, email address, telephone number and photograph</span>.
    </span></p>

  <p style='margin:0in;text-align:justify;text-justify:inter-ideograph;
background:transparent'><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>&nbsp;</span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;text-indent:-.5in;background:
transparent'><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>3.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>Other terms used in this Notice shall have the meanings given to
      them in the PDPA (where the context so permits).</span></p>

  <p class=MsoListParagraph style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif'> </span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif'>COLLECTION, USE AND DISCLOSURE OF PERSONAL DATA</span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoListParagraphCxSpFirst style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span style='font-family:"Arial",sans-serif'>4.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>We generally do not collect your personal data unless (a) it is
      provided to us voluntarily by you directly or via a third party who has been
      duly authorised by you to disclose your personal data to us (your “<b>authorised
        representative</b>”) after (i) you (or your authorised representative) have
      been notified of the purposes for which the data is collected, and (ii) you (or
      your authorised representative) have provided written consent to the collection
      and usage of your personal data for those purposes, or (b) collection and use
      of personal data without consent is permitted or required by the PDPA or other
      laws. We shall seek your consent before collecting any additional personal data
      and before using your personal data for a purpose which has not been notified
      to you (except where permitted or authorised by law).</span></p>

  <p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-justify:
inter-ideograph'><span lang=EN-SG style='font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-justify:
inter-ideograph;text-indent:-.5in'><span lang=EN-SG style='font-family:"Arial",sans-serif'>5.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif'>We may
      collect and use your personal data for any or all of the following purposes:</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif'>&nbsp;</span>
  </p>

  <p class=MsoListParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(a)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>performing obligations in the course of or in connection
      with our provision of the goods and/or services requested by you;</span></p>

  <p class=MsoListParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(b)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>verifying your identity;</span></p>

  <p class=MsoListParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(c)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>responding to, handling, and processing queries, requests,
      applications, complaints, and feedback from you;</span></p>

  <p class=MsoListParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(d)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>managing your relationship with us;</span></p>

  <p class=MsoListParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(e)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>processing payment or credit transactions; and</span></p>

  <p class=MsoListParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(f)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>any other purposes for which you have provided the
      information.</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><u><span lang=EN-SG
          style='font-family:"Arial",sans-serif;color:white'><span style='text-decoration:
 none'>&nbsp;</span></span></u></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>6.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>We may disclose your personal data:</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:0in;
margin-bottom:0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(a)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white;background:transparent'>where such disclosure is required for performing
      obligations in the course of or in connection with our provision of the goods
      and services requested by you; or</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-top:0in;margin-right:0in;
margin-bottom:0in;margin-left:1.0in;text-align:justify;text-justify:inter-ideograph;
text-indent:-.5in;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
background:transparent'>(b)<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white;background:transparent'>to third party service providers, agents and
      other organisations we have engaged to perform any of the functions with
      reference to the above mentioned purposes.</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><span style='font-family:"Arial",sans-serif'>&nbsp;</span></p>

  <p class=MsoListParagraph style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white;background:transparent'>7.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white;background:transparent'>The purposes listed in the above clauses may
      continue to apply even in situations where your relationship with us (for
      example, pursuant to a contract) has been terminated or altered in any way, for
      a reasonable period thereafter (including, where applicable, a period to enable
      us to enforce our rights under a contract with you).</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>&nbsp;</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'>WITHDRAWING YOUR CONSENT </span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoListParagraphCxSpFirst style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>8.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>The consent that you provide for the collection, use and
      disclosure of your personal data will remain valid until such time it is being
      withdrawn by you in writing. You may withdraw consent and request us to stop collecting,
      using and/or disclosing your personal data for any or all of the purposes
      listed above by submitting your request in writing or via email to our Data
      Protection Officer at the contact details provided below.</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>9.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>Upon receipt of your written request to withdraw your consent, we
      may require reasonable time (depending on the complexity of the request and its
      impact on our relationship with you) for your request to be processed and for
      us to notify you of the consequences of us acceding to the same, including any
      legal consequences which may affect your rights and liabilities to us. In
      general, we shall seek to process your request within <span style='background:
transparent'>thirty (30)</span> business days of receiving it. </span></p>

  <p class=MsoListParagraphCxSpMiddle><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>10.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>Whilst we respect your decision to withdraw your consent, please
      note that depending on the nature and scope of your request, we may not be in a
      position to continue providing our goods or services to you and we shall, in
      such circumstances, notify you before completing the processing of your request.
      Should you decide to cancel your withdrawal of consent, please inform us in
      writing in the manner described in <span style='background:transparent'>clause 8</span>
      above. </span></p>

  <p class=MsoListParagraphCxSpMiddle style='text-align:justify;text-justify:
inter-ideograph'><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>11.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif'>Please
      note that withdrawing consent does not affect our right to continue to collect,
      use and disclose personal data where such collection, use and disclose without
      consent is permitted or required under applicable laws.</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><u><span lang=EN-SG
          style='font-family:"Arial",sans-serif;color:white'>ACCESS TO AND CORRECTION OF
          PERSONAL DATA</span></u></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>12.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>If you wish to make (a) an access request for access to a copy of
      the personal data which we hold about you or information about the ways in
      which we use or disclose your personal data, or (b) a correction request to
      correct or update any of your personal data which we hold about you, you may
      submit your request in writing or via email to our Data Protection Officer at
      the contact details provided below. </span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>13.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>Please note that a reasonable fee may be charged for an access
      request. If so, we will inform you of the fee before processing your request. </span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>&nbsp;</span></p>

  <p class=MsoListParagraph style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>14.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>We will respond to your request as soon as reasonably possible. In
      general, our response will be within <span style='background:transparent'>thirty
        (30)</span> business days. Should we not be able to respond to your request
      within thirty (30) days after receiving your request, we will inform you in
      writing within thirty (30) days of the time by which we will be able to respond
      to your request.</span><span lang=EN-SG style='font-family:"Arial",sans-serif'>
      If we are unable to provide you with any personal data or to make a correction
      requested by you, we shall generally inform you of the reasons why we are
      unable to do so (except where we are not required to do so under the PDPA).</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'>PROTECTION OF PERSONAL DATA</span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;text-indent:-.5in;background:
transparent'><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>15.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>To safeguard your personal data from unauthorised access,
      collection, use, disclosure, copying, modification, disposal or similar risks,
      we have introduced appropriate administrative, physical and technical measures
      such as <span style='background:transparent'>minimised collection of personal data,
        data anonymisation, regular patching of operating system and other software,
        and security review and testing performed regularly</span>. </span></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;background:transparent'><b><i><span lang=EN-SG
          style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'>&nbsp;</span></i></b></p>

  <p class=MsoListParagraphCxSpFirst style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>16.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>You should be aware, however, that no method of transmission over
      the Internet or method of electronic storage is completely secure. While
      security cannot be guaranteed, we strive to protect the security of your
      information and are constantly reviewing and enhancing our information security
      measures.</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><i><span lang=EN-SG
          style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></i></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><u><span lang=EN-SG
          style='font-family:"Arial",sans-serif;color:white'>ACCURACY OF PERSONAL DATA</span></u></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><u><span lang=EN-SG
          style='font-family:"Arial",sans-serif;color:white'><span style='text-decoration:
 none'>&nbsp;</span></span></u></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>17.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif'>We
      generally rely on personal data provided by you (or your authorised
      representative). In order to ensure that your personal data is current,
      complete and accurate, please update us if there are changes to your personal
      data by informing <span style='color:white'>our Data Protection Officer in
        writing or via email at the contact details provided below.</span></span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><span lang=EN-SG
        style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><u><span lang=EN-SG
          style='font-family:"Arial",sans-serif;color:white'>RETENTION OF PERSONAL DATA </span></u></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><b><u><span lang=EN-SG
          style='font-family:"Arial",sans-serif;color:white'><span style='text-decoration:
 none'>&nbsp;</span></span></u></b></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>18.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif'>We may
      retain your personal data for as long as it is necessary to fulfil the purpose
      for which it was collected, or as required or permitted by applicable laws.</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>19.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif'>We will
      cease to retain your personal data, or remove the means by which the data can
      be associated with you, as soon as it is reasonable to assume that such
      retention no longer serves the purpose for which the personal data was
      collected, and is no longer necessary for legal or business purposes.</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'>TRANSFERS OF PERSONAL DATA OUTSIDE OF SINGAPORE</span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><i><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'>&nbsp;</span></i></b></p>

  <p class=MsoListParagraph style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>20.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>We generally do not transfer your personal data to countries
      outside of Singapore. However, if we do so, we will obtain your consent for the
      transfer to be made and we will take steps to ensure that your personal data
      continues to receive a standard of protection that is at least comparable to
      that provided under the PDPA.</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'>DATA PROTECTION OFFICER</span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p style='margin-top:0in;margin-right:0in;margin-bottom:0in;margin-left:.5in;
text-align:justify;text-justify:inter-ideograph;text-indent:-.5in;background:
transparent'><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>21.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-size:11.0pt;font-family:"Arial",sans-serif;
color:white'>You may </span><span lang=EN-SG style='font-size:11.0pt;
font-family:"Arial",sans-serif;color:white'>contact our </span><span lang=EN-SG
      style='font-size:11.0pt;font-family:"Arial",sans-serif;color:white'>Data
      Protection Officer if you have any enquiries or feedback on our personal data
      protection policies and procedures, or if you wish to make any request, in the
      following manner</span><span lang=EN-SG style='font-size:11.0pt;font-family:
"Arial",sans-serif;color:white'>: </span></p>

  <p class=MsoListParagraphCxSpFirst style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white;background:transparent'>Name of
      DPO : LIU KONG</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white;background:transparent'>Contact
      No. : 91318317</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white;background:transparent'>Email
      Address : luke.liumsconsultancy.com.sg</span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'>EFFECT OF NOTICE AND CHANGES TO NOTICE</span></u></b></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <p class=MsoListParagraphCxSpFirst style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>22.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>This Notice applies in conjunction with any other notices,
      contractual clauses and consent clauses that apply in relation to the
      collection, use and disclosure of your personal data by us.</span></p>

  <p class=MsoListParagraphCxSpMiddle style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>&nbsp;</span></p>

  <p class=MsoListParagraphCxSpLast style='margin-bottom:0in;text-align:justify;
text-justify:inter-ideograph;text-indent:-.5in;line-height:normal'><span lang=EN-SG
      style='font-family:"Arial",sans-serif;color:white'>23.<span
        style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span lang=EN-SG style='font-family:"Arial",sans-serif;
color:white'>We may revise this Notice from time to time without any prior notice.
      You may determine if any such revision has taken place by referring to the date
      on which this Notice was last updated. Your continued use of our services
      constitutes your acknowledgement and acceptance of such changes. </span></p>

  <p class=MsoNormal style='margin-bottom:0in;text-align:justify;text-justify:
inter-ideograph;line-height:normal'><b><u><span lang=EN-SG style='font-family:
"Arial",sans-serif;color:white'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>

  <h2 style='margin-top:0in;margin-right:0in;margin-bottom:10.0pt;margin-left:
0in;text-indent:0in;line-height:normal;background:transparent'><span lang=EN-SG
      style='font-size:11.0pt;color:white;background:transparent'>Effective date : 27/08/2024<br>
    </span><span lang=EN-SG style='font-size:11.0pt;color:white;background:transparent'>Last
      updated : 27/08/2024</span></h2>

</div>